export default function StockImageLabel() {
  return (
    <span
      className="absolute bottom-0 right-2xl md:-bottom-3xl md:right-[8.33px] whitespace-nowrap text-text-disabled-subtle t-label-xs"
      data-testid="why-buy-stock-image-label"
    >
      Stock image
    </span>
  );
}
